import { authRoutes } from 'features/Auth';
import { appointmentsRoutes } from 'features/Appointments';
import { skuOrdersRoutes } from 'features/Sku/Orders';
import { HomeRoutes } from 'features/Home';
import { integrationsRoutes } from 'features/Integrations';
import { itemsRoutes } from 'features/Items';
import { modifierRoutes } from 'features/Sku/Modifiers';
import { createYieldManagementRoutes } from 'features/YieldManagement';
import { accountRoutes } from 'features/Account';
import { opportunitiesRoutes } from 'features/Opportunities';
import { printRosterRoutes } from 'features/PrintRoster';
import { campaignsRoutes } from 'features/Campaigns';
import { ratingsRoutes } from 'features/Ratings';
import { smartRateRoutes } from 'features/SmartRate';
import { statsRoutes } from 'features/Stats';
import { migrateRoutes } from 'features/Migrate';
import { NotFound } from '../features/NotFound';
import managePageRoutes from './ManagePage.routes';
import venuePageRoutes from './VenuePage.routes';
import legalRoutes from './Legal.routes';
import redirectedRoutes from './redirects';
import { connectRoutes } from '../features/Connect';

// Excluded from prod builds: dev-only sandbox, no UI links to /component-examples.
// eslint-disable-next-line global-require
const componentExamplesRoutes =
  process.env.NODE_ENV === 'production' ? [] : require('features/ComponentExamples').componentExamplesRoutes;

export const NOT_FOUND_PATH = '/*';

export default [
  redirectedRoutes,
  authRoutes,
  appointmentsRoutes,
  skuOrdersRoutes,
  integrationsRoutes,
  itemsRoutes,
  modifierRoutes,
  opportunitiesRoutes,
  managePageRoutes,
  createYieldManagementRoutes,
  printRosterRoutes,
  campaignsRoutes,
  ratingsRoutes,
  smartRateRoutes,
  venuePageRoutes,
  HomeRoutes,
  statsRoutes,
  accountRoutes,
  migrateRoutes,
  legalRoutes,
  connectRoutes,
  // error
  {
    path: '/error',
    component: NotFound,
    isFixedPage: true,
    isPublic: true,
  },
  componentExamplesRoutes,
  // 404
  {
    path: NOT_FOUND_PATH,
    component: NotFound,
    isFixedPage: true,
    isPublic: true,
  },
].flat();
